import React, { useState } from 'react';

// Fairy logo mark. Tries to load fairy-logo.png from public/images/broker-analyzer/.
// Falls back to an on-brand SVG silhouette if the file is missing.
export default function BrandLogoMark({ className = '' }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <svg
        viewBox="0 0 120 120"
        className={'rounded-2xl shadow-lg ' + className}
        aria-label="I Need Numbers fairy logo"
      >
        <defs>
          <radialGradient id="btaLogoBg" cx="30%" cy="30%" r="80%">
            <stop offset="0%" stopColor="#5EC389" />
            <stop offset="100%" stopColor="#2FA163" />
          </radialGradient>
        </defs>
        <rect x="0" y="0" width="120" height="120" rx="22" fill="url(#btaLogoBg)" />
        <path d="M48 42 Q20 28 18 52 Q28 68 50 58 Z" fill="#5EC389" fillOpacity="0.55" />
        <path d="M46 52 Q22 72 32 92 Q46 86 52 68 Z" fill="#5EC389" fillOpacity="0.55" />
        <path d="M48 42 Q20 28 18 52 Q28 68 50 58 Z" fill="none" stroke="#092825" strokeWidth="1.2" />
        <path d="M46 52 Q22 72 32 92 Q46 86 52 68 Z" fill="none" stroke="#092825" strokeWidth="1.2" />
        <circle cx="64" cy="36" r="7" fill="#092825" />
        <path d="M57 33 Q50 25 48 18 Q56 22 62 28 Z" fill="#092825" />
        <path d="M60 43 Q54 50 52 60 L46 98 Q42 108 32 112 Q28 110 30 104 Q34 96 36 88 L40 68 Q43 55 50 48 L60 43 Z" fill="#092825" />
        <path d="M66 46 Q76 44 84 50 Q86 52 84 54 L78 52 Q72 52 66 51 Z" fill="#092825" />
      </svg>
    );
  }

  return (
    <img
      src="/images/broker-analyzer/fairy-logo.png"
      alt="I Need Numbers fairy logo"
      className={'rounded-2xl shadow-lg ' + className}
      onError={() => setFailed(true)}
      data-testid="bta-logo-mark"
    />
  );
}
